import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import type * as ApiModels from '@/typings/api-models';

type ThisApi = ApiDefinition['/invoices/{creatorId}/authorized-user-invoices.csv']['GET'];

type Input = ThisApi['params'] &
  Omit<ThisApi['query'], 'filters'> & {
    filters?: ApiModels.INVOICE_STATUS[];
  };

const getEmployerPocInvoiceCsv = async ({
  creatorId,
  filter,
  startDate,
  endDate,
  search,
}: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/invoices/${creatorId}/authorized-user-invoices.csv`, {
    params: {
      endDate,
      filter,
      search,
      startDate,
    },
  });
  return response.data;
};

export default getEmployerPocInvoiceCsv;
